import classNames from 'clsx'
import { bool, oneOf, string } from 'prop-types'

import { PAGE_TYPE_SEARCH_RESULTS, PAGE_TYPES } from 'shared/consts/page'
import FilterBoxVariant from 'shared/experiments/components/NewSerp/FilterBox'
import InfiniteHits from 'shared/experiments/components/SerpLoadMore/InfiniteHits'
import SerpNowPushWidget from 'shared/experiments/components/SerpNowPush/SerpNowPushWidget'
import {
  EXPERIMENT_VARIATION,
  SERP_LOAD_MORE,
  SERP_NOW_PUSH,
} from 'shared/experiments/consts'
import FilterBox from 'views/components/organisms/AlgoliaInstantSearch/Algolia/FilterBox'
import Pagination from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Pagination'
import RegularHits from 'views/components/organisms/AlgoliaInstantSearch/Algolia/RegularHits'
import { shouldBeShippedToday } from 'views/components/organisms/NowCountdown/helpers'
import Experiment from 'views/components/utils/optimizely/Experiment'

const ProductFilterHits = ({
  query,
  indexName,
  className,
  pageType,
  noveltiesIndexName,
  isFilterApplied,
}) => {
  const isSearchPage = pageType === PAGE_TYPE_SEARCH_RESULTS
  const shouldRenderLoadMoreExperiment = exp =>
    isSearchPage && exp.variant !== EXPERIMENT_VARIATION.DEFAULT
  const shouldRenderNowPushWidgetExperiment =
    isSearchPage && shouldBeShippedToday()

  return (
    <>
      <div className={classNames(className, 'u-margin--bottom')}>
        {isSearchPage ? (
          <FilterBoxVariant indexName={indexName} />
        ) : (
          <FilterBox
            indexName={indexName}
            noveltiesIndexName={noveltiesIndexName}
          />
        )}
        {shouldRenderNowPushWidgetExperiment && (
          <Experiment name={SERP_NOW_PUSH}>
            {experiment =>
              experiment.variant === EXPERIMENT_VARIATION.V2 && (
                <SerpNowPushWidget />
              )
            }
          </Experiment>
        )}
        <Experiment name={SERP_LOAD_MORE}>
          {experiment =>
            shouldRenderLoadMoreExperiment(experiment) ? (
              <InfiniteHits query={query} isFilterApplied={isFilterApplied} />
            ) : (
              <RegularHits query={query} isFilterApplied={isFilterApplied} />
            )
          }
        </Experiment>
      </div>

      <Experiment name={SERP_LOAD_MORE}>
        {experiment =>
          shouldRenderLoadMoreExperiment(experiment) ? null : (
            <Pagination scrollToTopAfterClick />
          )
        }
      </Experiment>
    </>
  )
}

ProductFilterHits.propTypes = {
  indexName: string.isRequired,
  pageType: oneOf(PAGE_TYPES).isRequired,
  query: string,
  className: string,
  noveltiesIndexName: string,
  isFilterApplied: bool,
}

ProductFilterHits.defaultProps = {
  query: null,
  className: null,
  noveltiesIndexName: null,
  isFilterApplied: false,
}

export default ProductFilterHits
